import React, { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { EIncomeLevel } from '../../../typings'
import { TreemapChartVis } from '../..'
import { useWindowDimensions } from '../../../hooks'

interface Props {
	data: Charts.TreemapData
	level: Entities.Income.Level
}

const ExploreIncomesLevel: React.FC<Props> = ({ data, level }) => {
	const history = useHistory()
	const { pathname, state } = useLocation()
	const { x, y } = useWindowDimensions()
	const handleLeafClick = useCallback(
		(leaf: any) => {
			switch (level) {
				case EIncomeLevel.Federal:
					if (leaf.data.realTitle) {
						return history.push(pathname + `/año/${leaf.data.realTitle}`)
					}

					break

				case EIncomeLevel.Quarter:
					if (leaf.data.realTitle) {
						return history.push(pathname + `/cuarto/${leaf.data.realTitle}`)
					}

					break

				case EIncomeLevel.Institution:
					if (leaf.data.id) {
						return history.push(pathname + `/ministerio/${leaf.data.id}`, {
							...state,
							institutionName: leaf.data.realTitle,
						})
					}

					break

				case EIncomeLevel.Entity:
					if (leaf.data.id) {
						return history.push(pathname + `/entidad/${leaf.data.id}`, {
							...state,
							entityName: leaf.data.realTitle,
						})
					}

					break

				case EIncomeLevel.Program:
					if (leaf.data.id) {
						return history.push(pathname + `/programa/${leaf.data.id}`, {
							...state,
							programName: leaf.data.realTitle,
						})
					}

					break

				default:
					throw new Error('Nivel inválido')
			}
		},
		[history, pathname, level, state]
	)

	const chartWidthToWindowWidthRatio = useMemo(() => {
		if (x >= 1800) {
			return 0.95
		} else if (x >= 1200) {
			return 0.925
		} else if (x >= 767) {
			return 0.91
		} else {
			return 0.825
		}
	}, [x])

	const chartHeightToWindowHeightRatio = useMemo(() => {
		if (y >= 700) {
			return 0.812
		} else if (y >= 600) {
			return 0.75
		} else {
			return 0.7
		}
	}, [y])

	return (
		<TreemapChartVis
			title='Explorar Gastos'
			dimensions={[
				x * chartWidthToWindowWidthRatio,
				y * chartHeightToWindowHeightRatio,
			]}
			data={data}
			onLeafClick={handleLeafClick}
		/>
	)
}

export default ExploreIncomesLevel
